module.exports = __webpack_public_path__ + "img/horizontal-logo.302319e5.svg";